var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolInnerPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.016,
    height: 14.016,
    viewBox: "0 0 14.016 14.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2413",
    "data-name": "Group 2413",
    transform: "translate(-2905 -916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M487.341,187.838v2.92h2.92l8.617-8.617-2.92-2.92Z",
    transform: "translate(2417.658 739.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M499.772,179.145l-1.819-1.819a.781.781,0,0,0-1.1,0l-1.425,1.425,2.92,2.92,1.425-1.425A.779.779,0,0,0,499.772,179.145Z",
    transform: "translate(2419.016 738.901)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolInnerPencil);
export default __webpack_public_path__ + "static/media/school_inner_pencil.705a7d00227f620073f091b9e6cd3066.svg";
export { ForwardRef as ReactComponent };